import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {HoldingReportListItemReqRes} from 'src/app/shared/models/HoldingReportListItemReqRes.model';
import {HttpService} from '../http.service';
import {SearchOptionsRequest} from 'src/app/shared/models/SearchOptionsRequest.model';
import {SearchOptionsResponse} from 'src/app/shared/models/SearchOptionsResponse.model';
import {AssetReportReqRes} from 'src/app/shared/models/AssetReportReqRes.model';

@Injectable()
export class AssetReportDataService {
  generateEndpointPrefix(assetId: number) {
    return `assets/${assetId}/reports/`;
  }

  generateEndpointPrefixForLp(assetId: number) {
    return `lp/assets/${assetId}/reports/`;
  }

  constructor(private http: HttpService) {
  }

  protected getSearchOptionsToQuerystring(options: SearchOptionsRequest): string {
    return `?filter=${options.filter ? options.filter : ''}&sortOrder=${options.sortOrder ? options.sortOrder : ''}&pageNumber=${
      options.pageNumber ? options.pageNumber : 0
    }&pageSize=${options.pageSize}`;
  }

  public getList(assetId: number, options: SearchOptionsRequest): Observable<SearchOptionsResponse<HoldingReportListItemReqRes>> {
    const querystring = options ? this.getSearchOptionsToQuerystring(options) : '';
    return this.http.getTyped<SearchOptionsResponse<HoldingReportListItemReqRes>>(this.generateEndpointPrefix(assetId) + querystring).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public getByIdForGp(assetId: number, reportId: number): Observable<AssetReportReqRes> {
    return this.http.getTyped<AssetReportReqRes>(this.generateEndpointPrefix(assetId) + reportId).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public getByIdForLp(assetId: number, reportId: number): Observable<AssetReportReqRes> {
    return this.http.getTyped<AssetReportReqRes>(this.generateEndpointPrefixForLp(assetId) + reportId).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public create(assetId: number, model: AssetReportReqRes): Observable<AssetReportReqRes> {
    return this.http.postTyped<AssetReportReqRes>(this.generateEndpointPrefix(assetId), model).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public update(assetId: number, reportId: number, model: AssetReportReqRes): Observable<AssetReportReqRes> {
    return this.http.putTyped<AssetReportReqRes>(this.generateEndpointPrefix(assetId) + reportId, model).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public delete(assetId: number, reportId: number): Observable<void> {
    return this.http.deleteTyped<void>(this.generateEndpointPrefix(assetId) + reportId).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public publishReport(assetId: number, reportId: number, sendEmail: boolean, includeSummaryToReport:boolean, includeAttachedReport:boolean, includeAdditionalAttachments:boolean): Observable<object> {
    let obj = { sendEmail, includeSummaryToReport, includeAttachedReport, includeAdditionalAttachments };
    return this.http.put(`${this.generateEndpointPrefix(assetId)}${reportId}/publish`, obj).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }
}
